'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionTriggerConfigurationModal', ['$scope', '$modalInstance', 'TGTriggerConfigurations', function ($scope, $modalInstance, TGTriggerConfigurations) {
        $scope.trigger_configuration = {};
        $scope.saving = false;

        $scope.save = function () {
            $scope.saving = true;
            $scope.trigger_configuration.code = $scope.trigger_configuration.name.toLowerCase().replace(/\ /g, '_');
            TGTriggerConfigurations.save($scope.trigger_configuration).then(function (newConfiguration) {
                $scope.saving = false;
                $modalInstance.close(newConfiguration);
            })
        }

        $scope.close = function () {
            $modalInstance.dismiss('cancel');
        }
    }])
;